import "../../styles/user/profileHeader.css";
import capitalize from "../../utils/capitalize.js";
import { formatDate } from "../../utils/date.js";

const ProfileHeader = ({ user, isLoading, error }) => {
  if (!user) {
    return (
      <section className="profile-header loading">Loading profile...</section>
    );
  }

  if (error) {
    return <section className="profile-header error">{error}</section>;
  }

  const {
    firstName,
    lastName,
    email,
    bio,
    avatar,
    publicationsCount,
    createdAt,
  } = user;

  const initials = `${firstName?.[0] || ""}${
    lastName?.[0] || ""
  }`.toUpperCase();

  return (
    <section className="profile-header">
      <div className="profile-header-inner">
        <div className="profile-avatar">
          {avatar ? (
            <img src={avatar} alt="avatar" />
          ) : (
            <div className="avatar-fallback">{initials}</div>
          )}
        </div>

        <div className="profile-info">
          <h1 className="profile-name">
            {capitalize(firstName)} {capitalize(lastName)}
          </h1>

          <p className="profile-email">{email}</p>

          <p className="profile-bio">{bio || "No bio added yet."}</p>

          <div className="profile-meta">
            <span>{publicationsCount} Visualizations</span>
            <span>Joined · {formatDate(createdAt)}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProfileHeader;
